export const navObj = [
  {
    name: "main",
    toPath: "/",
    content: "Main page",
    key: "0000",
  },
  {
    name: "users",
    toPath: "/users",
    content: "Users page",
    key: "0001",
  },
  {
    name: "tags",
    toPath: "/tags",
    content: "Tags page",
    key: "0010",
  },
];
